import { Text, tokens } from '@fluentui/react-components';
import CheckoutBox from 'components/core/CheckoutBox/CheckoutBox';
import { useCart } from 'contexts/CartContext/CartContext.hooks';
import { useNextStepsStyles } from './NextSteps.styles';
import { useCallback, useEffect, useMemo, useState } from 'react';
import MainButton from 'components/core/MainButton/MainButton';
import { HubspotWindow } from 'types/HubSpot';
import { usePaymentStatus } from 'contexts/PaymentContext/PaymentContext.hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

declare let window: HubspotWindow;

const NextSteps = () => {
    const styles = useNextStepsStyles();

    const { confirmOrder } = useCart();
    const { resetPayment, due } = usePaymentStatus();

    const [confirmationId, setConfirmationId] = useState('');

    useEffect(() => {
        const id = confirmOrder();
        setConfirmationId(id);
        resetPayment();
    }, []);

    const confirmationText = useMemo(() => {
        return `Your Order Confirmation #${confirmationId}`;
    }, [confirmationId]);

    const handleContactClick = useCallback(() => (window.location.href = '/contact'), []);

    const handleChatWithUs = () => {
        if (window.HubSpotConversations) {
            window.HubSpotConversations.widget.open();
        }
    };

    return (
        <div>
            <CheckoutBox className={styles.successBox}>
                <FontAwesomeIcon
                    size='2xl'
                    icon={faCircleCheck}
                    color={tokens.colorPaletteGreenForeground2}
                />
                <Text weight='medium' size={400}>
                    Payment of ${due.toFixed(2)} has been completed
                </Text>
            </CheckoutBox>

            <CheckoutBox>
                <div className={styles.shippingSection}>
                    <Text size={500} weight='semibold'>
                        {confirmationText}
                    </Text>
                    <Text>
                        Thank you for joining our Viaero family, with the best cellular and internet
                        in the area.
                    </Text>
                    <Text>
                        Your order is processing and a Viaero eCommerce Concierge will be in touch
                        with an order confirmation email shortly.
                    </Text>
                </div>
            </CheckoutBox>

            <CheckoutBox className={styles.questionsSection}>
                <div className={styles.shippingSection}>
                    <Text size={400} weight='semibold'>
                        Have more Questions?
                    </Text>
                    <Text>
                        You can chat with us or call us at{' '}
                        <a href='tel:1-877-484-2376'>1-877-484-2376</a>.
                    </Text>
                    <div className={styles.questionButtons}>
                        <MainButton type='soft' text='Contact Us' onClick={handleContactClick} />
                        <MainButton type='primary' text='Chat with us' onClick={handleChatWithUs} />
                    </div>
                </div>
            </CheckoutBox>
        </div>
    );
};

export default NextSteps;
